module.exports = __webpack_public_path__ + "img/minbannerb.350e3d27.png";